export function numberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatNumberToCurrency(number: number, options: Intl.NumberFormatOptions = {}) {
  return number.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    ...options,
  });
}

/** Whole-dollar amounts stay `$9`. Amounts with cents stay `$8.23`. */
export function formatCentsAmount(cents: number): string {
  const hasCents = cents % 100 !== 0;

  return formatNumberToCurrency(cents / 100, {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  });
}
